import React, { useState } from 'react';
import { Box, Button, TextField, Select, MenuItem, FormControl, InputLabel, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const RegistarColaborador = () => {
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [loading, setLoading] = useState(false); // Estado de carregamento

  const handleFormSubmit = async (values, actions) => {
    console.log("Submitting form with values:", values);
    setLoading(true); // Inicia o carregamento
    try {
      const payload = {
        nome: values.nome,
        email: values.email,
        cargo: values.cargo,
        tipo: values.tipo,
        senha: values.senha,
        valorHora: values.valorHora,
      };
      const response = await axios.post(`https://pf-auditores.ew.r.appspot.com/api/colaboradores`, payload);
      console.log("Colaborador registrado com sucesso:", response.data);
      actions.resetForm();
      navigate('/colaboradores');
    } catch (error) {
      console.error("Erro ao registrar colaborador:", error);
    } finally {
      setLoading(false); // Finaliza o carregamento
    }
  };

  const handleVoltarClick = () => {
    navigate(-1);
  };

  const checkoutSchema = yup.object().shape({
    nome: yup.string().required("Nome é obrigatório"),
    email: yup.string().email("Email inválido").required("Email é obrigatório"),
    cargo: yup.string().required("Cargo é obrigatório"),
    valorHora: yup.string().required("valor Hora é obrigatório"),
    tipo: yup.string().required("Tipo de acesso é obrigatório"),
    senha: yup.string().required("Palavra-Passe é obrigatória").min(6, "Palavra-Passe deve ter pelo menos 6 caracteres"),
    confirmarSenha: yup.string()
      .oneOf([yup.ref('senha'), null], 'Palavras-Passe devem coincidir')
      .required('Confirmação da Palavra-Passe é obrigatória'),
  });

  const initialValues = {
    nome: "",
    email: "",
    cargo: "",
    tipo: "",
    senha: "",
    confirmarSenha: "",
  };

  return (
    <Box m="20px">
      <Header title="Registar Colaborador" subtitle="Registar novo colaborador" />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nome"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.nome}
                name="nome"
                error={!!touched.nome && !!errors.nome}
                helperText={touched.nome && errors.nome}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="email"
                label="Email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={!!touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Cargo"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.cargo}
                name="cargo"
                error={!!touched.cargo && !!errors.cargo}
                helperText={touched.cargo && errors.cargo}
                sx={{ gridColumn: "span 1" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Valor Hora"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.valorHora}
                name="valorHora"
                error={!!touched.valorHora && !!errors.valorHora}
                helperText={touched.valorHora && errors.valorHora}
                sx={{ gridColumn: "span 1" }}
              />
              <FormControl fullWidth sx={{ gridColumn: "span 2" }}>
                <InputLabel id="tipo-label">Tipo de Acesso</InputLabel>
                <Select
                  labelId="tipo-label"
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("tipo", e.target.value);
                  }}
                  value={values.tipo}
                  name="tipo"
                  error={!!touched.tipo && !!errors.tipo}
                >
                  <MenuItem value="ADMIN">Admin</MenuItem>
                  <MenuItem value="BASICO">Básico</MenuItem>
                  <MenuItem value="EDITOR">Editor</MenuItem>
                </Select>
              </FormControl>
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Palavra-Passe"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.senha}
                name="senha"
                error={!!touched.senha && !!errors.senha}
                helperText={touched.senha && errors.senha}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Confirmar Palavra-Passe"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.confirmarSenha}
                name="confirmarSenha"
                error={!!touched.confirmarSenha && !!errors.confirmarSenha}
                helperText={touched.confirmarSenha && errors.confirmarSenha}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="space-between" mt="20px">
              <Button type="button" color="primary" variant="contained" onClick={handleVoltarClick}>
                Voltar
              </Button>
              <Button type="submit" color="secondary" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Submeter"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default RegistarColaborador;
